import { FONT } from "@/styles/common";
import { Center } from "@chakra-ui/react";
import styled from "@emotion/styled";

export const CustomCenter = styled(Center)`
    width: 100%;
    height: 480px;

    ${FONT("cormorant", 40, 500)}

    @media (max-width:${({ theme }) => theme.MEDIA.mobile}) {
        height: 240px;
    }
`;
